(function () {

    'use strict';

    angular.module('iplusjs.adresseAuswahl', [
        'lodash',
        'iplusjs.utils.adresse'
    ])
    .component('iplusjsAdresseAuswahl', {
        restrict: 'E',
        bindings: {
            adressen: '<iaaAdressen',
            onSelect: '&iaaOnSelect',
            filter: '<iaaFilter'
        },
        templateUrl: 'common/adresse/adresseAuswahl.html',
        controller: AdresseAuswahlController,
        controllerAs: 'adresseAuswahlVm'
    });

    AdresseAuswahlController.$inject = [
        'lodash',
        'AdresseUtilsService'
    ];
    function AdresseAuswahlController(_, AdresseUtilsService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.toggleAdressenList = toggleAdressenList;
        vm.uebernehmeAdresse = uebernehmeAdresse;

        function onInit() {
            vm.label = 'Weitere Adressen einblenden';
            vm.showAdressenList = false;
            vm.adressen = _.filter(vm.adressen, vm.filter);
            vm.hasAdressen = _.size(vm.adressen) > 1;
        }

        function onChanges(changes) {}

        function toggleAdressenList() {
            vm.showAdressenList = !vm.showAdressenList;
            vm.label = 'Weitere Adressen ' + (vm.showAdressenList ? 'ausblenden' : 'einblenden');
        }
        function uebernehmeAdresse(adresse) {
            vm.onSelect({
                adresse: AdresseUtilsService.getAdressObject(adresse)
            });

            toggleAdressenList();
        }
    }

})();
